/**
 *
 * Returns the first non-falsy value among the provided arguments, or a fallback if all are falsy.
 * @param primary
 * @param secondary
 * @param fallback
 * @returns {*|null}
 */
export const getPreferredValue = (primary, secondary, fallback = null) => (primary || secondary || fallback);
